/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientRequestList } from './HchbPatientRequestList';
import {
    HchbPatientRequestListFromJSON,
    HchbPatientRequestListFromJSONTyped,
    HchbPatientRequestListToJSON,
} from './HchbPatientRequestList';

/**
 * 
 * @export
 * @interface FindAllHchbPatientRequests200Response
 */
export interface FindAllHchbPatientRequests200Response {
    /**
     * 
     * @type {HchbPatientRequestList}
     * @memberof FindAllHchbPatientRequests200Response
     */
    data?: HchbPatientRequestList;
}

/**
 * Check if a given object implements the FindAllHchbPatientRequests200Response interface.
 */
export function instanceOfFindAllHchbPatientRequests200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbPatientRequests200ResponseFromJSON(json: any): FindAllHchbPatientRequests200Response {
    return FindAllHchbPatientRequests200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPatientRequests200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPatientRequests200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbPatientRequestListFromJSON(json['data']),
    };
}

export function FindAllHchbPatientRequests200ResponseToJSON(value?: FindAllHchbPatientRequests200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbPatientRequestListToJSON(value.data),
    };
}

